module.exports = __webpack_public_path__ + "static/media/2.2faefae0.png";